export enum Actions {
  MANAGE = 'manage',
  VIEW = 'view',
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete',
  PUBLISH = 'publish',
  UNPUBLISH = 'unpublish',
  EXECUTE = 'execute',
  CLONE = 'clone',
  IMPORT = 'import',
  EXPORT = 'export',
  SHARE = 'share',
  ARCHIVE = 'archive',
  RESTORE = 'restore',
  APPROVE = 'approve',
}
